var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"def-container"},[_c('page-head'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('nuxt')],1),_vm._v(" "),(_vm.$route.name.includes('index'))?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }